import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	seriesPickerDetailsLabel: {
		id: 'servicedesk-reports-common.table.series-picker.series-picker-details-label',
		defaultMessage: 'Details for',
		description: 'Label with dropdown to pick a particular series on specific date',
	},
	atDateTime: {
		id: 'servicedesk-reports-common.table.series-picker.at-date-time',
		defaultMessage: 'at {dateTimestamp}',
		description: 'Label with dropdown to pick a particular series at specific date time',
	},
	onDate: {
		id: 'servicedesk-reports-common.table.series-picker.on-date',
		defaultMessage: 'on {dateTimestamp}',
		description: 'Label with dropdown to pick a particular series on specific date',
	},
	inWeek: {
		id: 'servicedesk-reports-common.table.series-picker.in-week',
		defaultMessage: 'in week starting {dateTimestamp}',
		description: 'Label with dropdown to pick a particular series in week starting',
	},
	inMonth: {
		id: 'servicedesk-reports-common.table.series-picker.in-month',
		defaultMessage: 'in {dateTimestamp}',
		description: 'Label with dropdown to pick a particular series in month',
	},
	returnToSummary: {
		id: 'servicedesk-reports-common.table.series-picker.return-to-summary',
		defaultMessage: 'Return to summary table',
		description: 'Link to switch view to summary table',
	},
});
